import { gql } from '@apollo/client'

export default gql`
  mutation UpdateAccountName($name: String!, $tag: Int!) {
    updateName(input: { name: $name, tag: $tag })
  }
`
